<app-page-hero
  badge="الخدمات"
  title="خدماتنا المتخصصة"
  highlight="في التعاقد الزراعي"
  descriptionLine1="في أولاً، لا نُقدم لك مجرد فرصة تعاقدية، بل منظومة متكاملة من الخدمات التي تضمن نجاح"
  descriptionLine2="تجربتك معنا من البداية وحتى النهاية"
  bgImage="/images/bg.png"
>
</app-page-hero>
